module.exports = __webpack_public_path__ + "img/car_shina2_41.9c745a8a.jpg";